import { render, staticRenderFns } from "./IdManagerSplitId.vue?vue&type=template&id=1f256aa9&scoped=true&"
import script from "./IdManagerSplitId.vue?vue&type=script&lang=js&"
export * from "./IdManagerSplitId.vue?vue&type=script&lang=js&"
import style0 from "./IdManagerSplitId.vue?vue&type=style&index=0&id=1f256aa9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f256aa9",
  null
  
)

export default component.exports